import videojs from 'video.js';

const DEFAULTS = {
	events: [],
	intervalStartEvents: [],
	intervalStopEvents: []
};

/**
 * The events emitter for stat
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends EventTargetm
 */

class StatEmitter extends videojs.EventTarget {
	constructor(player, options) {
		super();
		this.options = Object.assign({}, DEFAULTS, options);

		this.player = player;
		this.persentageState = {};

		this.events = new Set(this.options.events
			.concat(this.options.intervalStartEvents)
			.concat(this.options.intervalStopEvents));

		this._addEvents();
	}

	_addEvents() {		
		this._resetPersentageState();

		this._addPlayerEvents();
		this._addCustomEvents();

		
		this.player.on('dispose', () => {
			this._resetPersentageState();
		});
	}

	_addPlayerEvents() {
		this.events.forEach((ev) => {
			this.player.on(ev, (data) => {
				this.trigger({
					type: ev,
					...data
				});
			});
		});
	}

	_addCustomEvents() {
		this.player.on('timeupdate', () => {
			var part = this.player.currentTime() / this.player.duration;
			 
			if ((part >= 25) && (!this.persentageState.firstQuartile)) {
				this.trigger('firstQuartile');
				this.persentageState.firstQuartile = 1;
			} else if ((part >= 50) && (!this.persentageState.midpoint)) {
				this.trigger('midpoint');
				this.persentageState.midpoint = 1;
			} else if ((part >= 75) && (!this.persentageState.thirdQuartile)) {
				this.trigger('thirdQuartile');
				this.persentageState.thirdQuartile = 1;
			}
		});

		this.player.on('error', () => {
			if (!this.utils.isAdPlaying()) this.trigger('contentError');
		});

		this.player.on('fullscreenchange', () => {
			this.player.isFullscreen() ? this.trigger('fullscreenOpen') : this.trigger('fullscreenClose');
		});

		this.player.on('volumechange', () => {
			if (this.player.muted() || this.player.volume() == 0) this.trigger('muted');
		});

		// user volume change, vast.firstPlay used to prevent native muted before play 
		this.player.on('vast.firstPlay', () => {
			this.player.on('volumechange', () => {
				if (this.player.muted() || this.player.volume() == 0) this.trigger('clickMuted');
			});
		});

		this.player.on('ready', () => {
			let controlBar = this.player.getChild('controlBar'),
				playBtn = controlBar && controlBar.getChild('playToggle');

			playBtn && playBtn.on('click', () => {
				playBtn.hasClass('vjs-paused') ? this.trigger('clickPlay') : this.trigger('clickPause');
			});

			let feedbackBtn = controlBar && controlBar.getChild('feedbackButton');
			feedbackBtn && feedbackBtn.on('click', () => {
				if (this.player.hasClass('vjs-feedback-opened')) this.trigger('clickFeedbackOpen');
			});

			let qualityList = this.player.quality_handler && this.player.quality_handler.qualities;
			qualityList && qualityList.addEventListener('user_quality_changed', () => {
				this.trigger('clickQualityItem');
			});
		});

		this.player.on('play', () => {
			this.player.vast && this.player.vast.isAdPlaying() ? this.trigger('vast.nativeAdPlay') : this.trigger('vast.nativeContentPlay');
		});

		let last_cur_time = this.player.currentTime() || 0;
		let timeupdate_suspend = false;
		this.player.setInterval(() => {
			if (this.player.vast && this.player.vast.isAdPlaying()) return; // no video timeupdate for vpaid 
			let t = this.player.currentTime();
			if (this.player.paused() || this.player.seeking()) return;

			if (last_cur_time && Math.abs(t - last_cur_time) < 0.5) {
				if (!timeupdate_suspend) {
					this.trigger('timeupdateSuspend');
					timeupdate_suspend = true;
				}
			} else if (timeupdate_suspend) {
				this.trigger('timeupdateResume');
				timeupdate_suspend = false;
			}
			last_cur_time = t;
		}, 2000);

	}

	_resetPersentageState() {
		this.persentageState = {
			firstQuartile: 0,
			midpoint: 0,
			thirdQuartile: 0
		};
	}
}

export default StatEmitter;
